<template>
    <nav class="navbar" role="navigation" aria-label="hauptnavigation">
        <div class="navbar-logo">
            <a class="navbar-logo-link" href="/">
                <img src="https://www.marmor-kunze.de/static/logo/logo.jpg" alt="Marmor Kunze Startseite" width="112" height="28">
            </a>
        </div>
        <button class="navbar-burger-button" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
        </button>
        <div class="navbar-menu" :class="[navVisible ? 'visible' : '']"  >
            <navbaritem v-for="item in this.structure" :key="item.id" :title="item.id" :link="item.link" :sub="item.sub" ></navbaritem>
        </div>
            
  </nav>
</template>
<script>
import { NavBarConfig } from '../../../config/navbar.config'
import navbaritem from './NavbarItem'
import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',
  components: { navbaritem },
  data(){
     
      return{
          structure: '',
           position: ''
      }
  },
  created(){
      this.structure = NavBarConfig.structure;
      //this.position = (NAVBAR_CONFIG.position === "right") ? 'navbar-end' : 'navbar-start';
      
  },
  methods:{
      toggleMenu: function(){
           let menuVisible = !this.navVisible
           this.$store.commit("system/CHANGE_NAV_VISIBILITY", menuVisible);
      }
  },
  computed:{
    
    ...mapGetters({
      navVisible : "system/navVisible"
    })
  },
  
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/interface/NavBar/NavBar.vue